import React, {useState, useEffect} from 'react';
import {NavLink, Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {
    getInfomationAccountFromToken,
    checkRoleUser
} from '../../../utils/helper';
import {role} from '../../../utils/define';
import {URI_INTERNAL} from '../../../utils/pathLocations';

const MenuSidebar = () => {
    const [t] = useTranslation();
    const account = getInfomationAccountFromToken();

    const handleLinkClick = (e) => {
        const link = e.target.closest('a');
        if (link && link.getAttribute('href') && link.getAttribute('href') !== '#') {
            if (window.innerWidth < 992) {
                document.body.classList.remove('sidebar-open');
                document.body.classList.add('sidebar-collapse');
            }
        }
    };

    let accountRoleXemBaoCao = false;
    let isEditor = false;

    if (account && account.role) {
        const userRole = account.role.split(',').map(r => r.trim().toLowerCase());
        accountRoleXemBaoCao =
            userRole.includes(role.Admin.toLowerCase()) || userRole.includes(role.XemBaoCao.toLowerCase());
        isEditor = userRole.includes('editor');
    }

    const navSystem = [
        {
            to: URI_INTERNAL.ACCOUNT_PATH,
            name: 'Tài khoản',
            exact: false,
            roles: [role.Admin, role.Manager]
        },
        // {
        //     to: URI_INTERNAL.ACCOUNTHIS_PATH,
        //     name: 'Tài khoản HIS',
        //     exact: false,
        //     roles: [role.Admin]
        // },
        // {
        //     to: URI_INTERNAL.EMAILCONFIG_PATH,
        //     name: 'Email gửi thông báo',
        //     exact: false,
        //     roles: [role.Admin]
        // },
        {
            to: URI_INTERNAL.LOG_PATH,
            name: 'Xem log',
            exact: false,
            roles: [role.Admin]
        }
        // {
        //     to: URI_INTERNAL.MOBILE_VERSION_PATH,
        //     name: 'Phiên bản Mobile',
        //     exact: false,
        //     roles: [role.Admin, role.Manager]
        // }
        // {
        //     to: URI_INTERNAL.CONTACT_PATH,
        //     name: 'Liên hệ',
        //     exact: false,
        //     roles: [role.Admin, role.Manager]
        // }
    ];
    const navReport = [
        {
            to: URI_INTERNAL.LOGIN_HISTORY_PATH,
            name: 'Báo cáo người dùng đăng nhập',
            exact: false,
            roles: [role.Admin, role.Manager]
        },
    ];
    const navDanhMuc = [
        {
            to: URI_INTERNAL.DANH_MUC_DON_VI,
            name: 'Danh mục đơn vị',
            exact: false,
            roles: [role.Admin, role.Manager]
        },
        {
            to: URI_INTERNAL.DANH_MUC_HOC_VI,
            name: 'Danh mục học vị',
            exact: false,
            roles: [role.Admin, role.Manager]
        },
        {
            to: URI_INTERNAL.DANH_MUC_CHUC_DANH,
            name: 'Danh mục chức danh khoa học',
            exact: false,
            roles: [role.Admin, role.Manager]
        },
        {
            to: URI_INTERNAL.DANH_MUC_CHUC_VU,
            name: 'Danh mục chức vụ',
            exact: false,
            roles: [role.Admin, role.Manager]
        }
    ];

    const navAdminOnly = [
        {
            to: '#', // TODO: Thay đổi đường dẫn thực tế ở đây
            name: 'Tính năng bảo mật',
            exact: false,
            roles: [role.Admin] // Chỉ có role.Admin mới nhìn thấy
        }
    ];

    // const navHome = [
    //     {
    //         to: URI_INTERNAL.CATEGORY_PATH,
    //         name: 'Danh mục',
    //         exact: false,
    //         roles: [role.Admin, role.Manager, role.Publisher, role.Editor]
    //     },
    //     {
    //         to: URI_INTERNAL.GIAODIEN_PATH,
    //         name: 'Thành phần giao diện',
    //         exact: false,
    //         roles: [role.Admin, role.Manager, role.Publisher, role.Editor]
    //     },
    //     {
    //         to: URI_INTERNAL.BANNER_PATH,
    //         name: 'Quảng cáo',
    //         exact: false,
    //         roles: [role.Admin, role.Manager, role.Publisher, role.Editor]
    //     },
    //     {
    //         to: URI_INTERNAL.PARTNER_PATH,
    //         name: 'Đối tác',
    //         exact: false,
    //         roles: [role.Admin, role.Manager, role.Publisher, role.Editor]
    //     },
    //     {
    //         to: URI_INTERNAL.SLIDE_PATH,
    //         name: 'Slide ảnh',
    //         exact: false,
    //         roles: [role.Admin, role.Manager, role.Publisher, role.Editor]
    //     }
    //     // {
    //     //     to: URI_INTERNAL.HTML5BANNER_PATH,
    //     //     name: 'File Html 5',
    //     //     exact: false,
    //     //     roles: [role.Admin, role.Manager, role.Publisher, role.Editor]
    //     // }
    // ];

    const navNghienCuuDaoTao = [
        {
            to: URI_INTERNAL.BAI_BAO_PATH,
            name: 'Bài báo công bố',
            exact: false,
            roles: [role.Admin, role.Manager, role.Publisher, role.Editor]
        },
        {
            to: URI_INTERNAL.DE_TAI_PATH,
            name: 'Nhiệm vụ KH&CN',
            exact: false,
            roles: [role.Admin, role.Manager, role.Publisher, role.Editor]
        },
        {
            to: URI_INTERNAL.SANG_CHE_PATH,
            name: 'Sáng chế',
            exact: false,
            roles: [role.Admin, role.Manager, role.Publisher, role.Editor]
        },
        {
            to: URI_INTERNAL.GIAI_THUONG_PATH,
            name: 'Giải thưởng NCKH',
            exact: false,
            roles: [role.Admin, role.Manager, role.Publisher, role.Editor]
        },
        {
            to: URI_INTERNAL.SACH_PATH,
            name: 'Sách biên soạn',
            exact: false,
            roles: [role.Admin, role.Manager, role.Publisher, role.Editor]
        },
        {
            to: URI_INTERNAL.HUONG_DAN_HOC_VIEN_PATH,
            name: 'Hướng dẫn học viên',
            exact: false,
            roles: [role.Admin, role.Manager, role.Publisher, role.Editor]
        },
        {
            to: URI_INTERNAL.GIAI_THUONG_DAO_TAO_PATH,
            name: 'Giải thưởng đào tạo',
            exact: false,
            roles: [role.Admin, role.Manager, role.Publisher, role.Editor]
        }
    ];

    const obMenus = [
        {
            titleParentMenu: 'Hoạt động NCKH & Đào tạo',
            icon: 'nav-icon fas fa-graduation-cap',
            childMenu: navNghienCuuDaoTao,
            roles: [role.Admin, role.Manager, role.Publisher, role.Editor]
        },
        // {
        //     titleParentMenu: 'Nhập liệu',
        //     icon: 'nav-icon fab fa-pagelines',
        //     childMenu: navNhapLieu,
        //     roles: [role.Admin, role.Manager, role.Editor]
        // },
        // {
        //     titleParentMenu: 'ChatBot',
        //     icon: 'nav-icon fa-solid fa-user-doctor',
        //     childMenu: navChatBot,
        //     roles: [role.Admin, role.Manager, role.Publisher, role.Editor]
        // },
        // {
        //     titleParentMenu: 'Thành phần trang chủ',
        //     icon: 'nav-icon fas fa-home',
        //     childMenu: navHome,
        //     roles: [role.Admin, role.Manager, role.Publisher, role.Editor]
        // },
        // {
        //     titleParentMenu: 'Nội dung bài viết',
        //     icon: 'nav-icon fas fa-newspaper',
        //     childMenu: navContent,
        //     roles: [role.Admin, role.Manager, role.Publisher, role.Editor]
        // },
        {
            titleParentMenu: 'Hệ thống',
            icon: 'nav-icon fas fa-cog',
            childMenu: navSystem,
            roles: [role.Admin, role.Manager]
        },
        {
            titleParentMenu: 'Quản lý Danh mục',
            icon: 'nav-icon fas fa-list',
            childMenu: navDanhMuc,
            roles: [role.Admin, role.Manager]
        },
        {
            titleParentMenu: 'Dành riêng Admin',
            icon: 'nav-icon fas fa-user-shield',
            childMenu: navAdminOnly,
            roles: [role.Admin] // Phân quyền chỉ dành cho Admin ở thư mục gốc
        }
        // {
        //     titleParentMenu: 'Landing Page',
        //     icon: 'nav-icon fas fa-pager',
        //     childMenu: navLanding,
        //     roles: [role.Admin, role.Manager, role.Publisher, role.Editor]
        // },
        // {
        //     titleParentMenu: 'Báo cáo',
        //     icon: 'nav-icon fas fa-table',
        //     childMenu: navReport,
        //     roles: [role.Admin, role.Manager]
        // }
    ];
    const havePermission = (roles) => {
        const user = getInfomationAccountFromToken();
        if (user) {
            return checkRoleUser(roles, user);
        }
        return false;
    };

    const [configData, setConfigData] = useState([]);

    const getData = () => {
        fetch('/config.json', {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }
        })
            .then(function (response) {
                console.log(response);
                return response.json();
            })
            .then(function (myJson) {
                console.log(myJson);
                setConfigData(myJson);
            });
    };

    useEffect(() => {
        getData();
    }, []);

    const [menuOpen, setMenuOpen] = useState({});

    const toggleMenu = (index) => {
        setMenuOpen((currentOpen) => ({
            ...currentOpen,
            [index]: !currentOpen[index]
        }));
    };

    return (
        <aside
            className="main-sidebar sidebar-dark-primary elevation-4"
            style={{zIndex: '9993'}}
        >
            <Link to="/" className="brand-link">
                <img
                    src="/img/logo.png"
                    alt="AdminLTE Logo"
                    className="brand-image img-circle elevation-3"
                    style={{opacity: '.8'}}
                />
                <span className="brand-text font-weight-light">
                    {/* {configData.NAME_OF_PROJECT} */}
                    Thống kê báo cáo
                </span>
            </Link>
            <div className="sidebar">
                <div className="user-panel mt-3 pb-3 mb-3 d-flex">
                    <div className="image">
                        <img
                            src="/img/default-profile.png"
                            className="img-circle elevation-2"
                            alt="User"
                        />
                    </div>
                    <div className="info">
                        <Link to="/profile" className="d-block">
                            {account
                                ? account.email
                                    ? account.email
                                    : account.username
                                : ''}
                        </Link>
                    </div>
                </div>
                <nav className="mt-2" onClick={handleLinkClick}>
                    <ul
                        className="nav nav-pills nav-sidebar flex-column"
                        data-widget="treeview"
                        role="menu"
                        data-accordion="false"
                    >
                        {accountRoleXemBaoCao ? (
                            <li className="nav-item">
                                <NavLink to="/" exact className="nav-link">
                                    <i className="nav-icon fas fa-tachometer-alt" />
                                    <p>{t('menusidebar.label.welcome')}</p>
                                </NavLink>
                            </li>
                        ) : (
                            <></>
                        )}
                        
                        {isEditor && (
                            <>
                                <li className="nav-item">
                                    <NavLink to={URI_INTERNAL.NHAN_VIEN_INPUT} className="nav-link">
                                        <i className="nav-icon fas fa-user-edit text-success" />
                                        <p>Thông tin chung</p>
                                    </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink to={URI_INTERNAL.PROFILE_CV} className="nav-link">
                                        <i className="nav-icon fas fa-university text-info" />
                                        <p>Lý lịch khoa học</p>
                                    </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink to={`${URI_INTERNAL.PROFILE_CV}?print=v2`} className="nav-link">
                                        <i className="nav-icon fas fa-print text-teal" />
                                        <p>In hồ sơ v2</p>
                                    </NavLink>
                                </li>
                            </>
                        )}

                        {!isEditor && (
                            <li className="nav-item">
                                <NavLink to={URI_INTERNAL.PROFILE_CV} className="nav-link">
                                    <i className="nav-icon fas fa-university text-info" />
                                    <p>Danh sách giảng viên</p>
                                </NavLink>
                            </li>
                        )}
                        
                        <li className="nav-item">
                            <NavLink to="/profile" exact className="nav-link">
                                <i className="nav-icon fas fa-key text-warning" />
                                <p>Đổi mật khẩu</p>
                            </NavLink>
                        </li>
                        {obMenus.map((item, index) => {
                            if (!havePermission(item.roles)) return null;
                            return (
                                <li className="nav-item" key={index}>
                                    <a
                                        // href="#"
                                        style={{cursor: 'pointer'}}
                                        className="nav-link"
                                        onClick={() =>
                                            toggleMenu(index)
                                        }
                                    >
                                        <i
                                            style={{
                                                marginRight: '10px'
                                            }}
                                            className={item.icon}
                                        />
                                        <p>
                                            {item.titleParentMenu}
                                            {item.childMenu.length >
                                            0 ? (
                                                <i className="fas fa-angle-left right" />
                                            ) : null}
                                        </p>
                                    </a>
                                    <ul
                                        className={`nav nav-treeview ${
                                            menuOpen[index]
                                                ? 'open'
                                                : ''
                                        }`}
                                        style={{
                                            // overflow: "hidden",
                                            display: 'block'
                                            // transition: "max-height 0.5s ease-out",
                                            // maxHeight: menuOpen[index]
                                            // ? '1000px'
                                            // : '0'
                                        }}
                                    >
                                        {item.childMenu.map(
                                            ({to, name, roles}, childIndex) => {
                                                if (!havePermission(roles)) return null;
                                                return (
                                                    <li className="nav-item" key={to || childIndex}>
                                                        <NavLink
                                                            to={to}
                                                            className="nav-link"
                                                        >
                                                            <i
                                                                style={{
                                                                    marginRight:
                                                                        '5px'
                                                                }}
                                                                className="far fa-circle nav-icon"
                                                            />
                                                            <p>
                                                                {
                                                                    name
                                                                }
                                                            </p>
                                                        </NavLink>
                                                    </li>
                                                );
                                            }
                                        )}
                                    </ul>
                                </li>
                            );
                        })}
                    </ul>
                </nav>
            </div>
        </aside>
    );
};

export default MenuSidebar;
